import {FormField} from "../form-field/form-field";

export class FormFieldSelectImage extends FormField{
    getVal(){
        const value = this.$value.val();
        if(this.$root.data("multiple")){
            if(value){
                return JSON.parse(value);
            }
        }
        return value;
    }

    setVal(val,noEvent){
        const $items = this.findMember("item").removeClass("is-selected");
        if(this.$root.data("multiple")==1){
            if(val){
                if(!$.isArray(val)){
                    val = JSON.parse(val);
                }
                val.forEach(
                    (v)=>{
                        $items.filter("[data-value='"+v+"']").addClass("is-selected");
                    }
                );
                this.$value.val(val.length>0?JSON.stringify(val):"");
            }else{
                this.$value.val("");
            }
        }else{
            this.$value.val(val);
            $items.filter("[data-value='"+val+"']").addClass("is-selected");
        }
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$value = this.findMember("value");
        this.findMember("item").click(
            (ev) => {
                if(this.$root.data("multiple")==1){
                    $(ev.currentTarget).toggleClass("is-selected");
                    let values = [];
                    this.findMember("item").filter(".is-selected").each(
                        (index,item)=>{
                            values.push($(item).data("value"));
                        }
                    );
                    this.setVal(values);
                }else{
                    const value = $(ev.currentTarget).data("value");
                    if(this.getVal()==value){
                        this.setVal("");
                    }else{
                        this.setVal(value);
                    }
                }
            }
        );
    }
}

